// extracted by mini-css-extract-plugin
module.exports = {"dataWrapper":"Header_dataWrapper__2L7i8","field":"Header_field__20mB7","header":"Header_header__3ogOU"};